import React, { useEffect, useState } from "react";
import { Alert, Box, Breadcrumbs, Button, Card, Stack } from "@mui/material";
import FeatherIcon from 'feather-icons-react';
import { CreateVisitorWLogin } from "./CreateVisitorWLogin";

import { Form, FormikProvider, useFormik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router";

import { toast } from "react-toastify";
import { routes } from "../../../../routes/routes";
import { GetAllDepartments, GetOfficeEmployee } from "../../../../services/admin";
import { AddOrUpdateVisitor, AddOrUpdateVisitorWithoutLogin, GetVisitorById } from "../../../../services/attendance-change";
import Visitor from "../../../../validationSchema/Visitor";
import PageContainer from "../../../../components/container/PageContainer";
// import { routes } from "../../../routes/routes";

const CreateVisitorW = () => {
  const { id } = useParams();
  const visitorid = id ? id : null;
  const [employeeData, setEmployeeData] = useState([]);
  const [departments, setDepartments] = useState([]);
  const location = useLocation();
  const view = location?.pathname?.includes("/visitor-view");
  const navigate = useNavigate();
  useEffect(() => {
    getEmployee();
    getDepartment();
    if (id) {
      getVisitorById(id);
    }
  }, []);

  const BCrumb = [
    {
      to: "/",
      title: "Attendance",
    },
    {
      title: `${visitorid ? (view ? "View" : "Edit") : "Add"} Visitor`,

    },
  ];

  const getEmployee = async () => {
    try {
      const response = await GetOfficeEmployee();
      if (response?.status === 200) {
        setEmployeeData(response?.data?.result);
      }
    } catch (e) {
      console.log(e, "error");
    }
  };
  const getDepartment = async () => {
    try {
      const response = await GetAllDepartments();
      if (response?.status === 200) {
        setDepartments(response?.data);
      }
    } catch (e) { }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
  
    const [datePart] = dateString.split(' ');
    
    // Extract day, month, and year
    const [day, month, year] = datePart.split('-');
  
    // Ensure all values are present and valid
    if (!day || !month || !year) {
      console.error("Invalid date format:", dateString);
      return '';
    }
  
    // Reformat to MM-DD-YYYY as you wanted
    return `${month}-${day}-${year}`;
  };
  
  const getVisitorById = async () => {
    try {
      const response = await GetVisitorById(visitorid);
      if (response?.status === 200) {
        const visitorData = response?.data;
  
        formik.setValues({
          ...visitorData,
          visitingPersonname: visitorData.visitingPersonName,
          contactNO: visitorData.contactNo,
          visitingDate: formatDate(visitorData.visitingDate), // Format as mm-dd-yyyy
          validUpto: formatDate(visitorData.validUpto), // Format as mm-dd-yyyy
          VisitingTime: new Date(visitorData.visitingTime).toLocaleTimeString('en-US', { hour12: false }),
        });
      }
    } catch (e) {
      console.log(e, 'error');
    }
  };
  
  const formik = useFormik({
    initialValues: {
      initiatorName: "",
      department: "",
      representing: "",
      contactNO: "",
      visitingPersonname: "",
      visitingDate: null,
      validUpto: null,
      VisitingTime: "",
      noofPerson: "",
      purpose: "",
      visitingType: "",
      visitorId: "",
      isSunday:false,
      out_Time:"",
    },
    onSubmit(values, { resetForm }) {
      addvisitor(values, resetForm);
    },
    enableReinitialize: true,
    validationSchema: Visitor,
  });
  const addvisitor = async (values, resetForm) => {
    const formattedTime = values.visitingTime
      ? new Date(`1970-01-01T${values.visitingTime}`).toLocaleTimeString('en-US', { hour12: false })
      : "";
    const Data = {
      ...(id && { id }),
      visitorId: values.visitorId,
      initiatorName: values.initiatorName,
      department: values.department,
      representing: values.representing,
      contactNO: values.contactNO,
      visitingPersonname: values.visitingPersonname,
      // visitingDate: new Date(values.visitingDate).toLocaleDateString(), // Only Date
      // validUpto: new Date(values.validUpto).toLocaleDateString(),       // Only Date
      visitingDate: new Date(values.visitingDate).toLocaleDateString('en-US'), // MM/DD/YYYY
      validUpto: new Date(values.validUpto).toLocaleDateString('en-US'), 
      visitingTime: formattedTime, // Only Time
      noofPerson: values.noofPerson,
      purpose: values.purpose,
      visitingType: values.visitingType,
      isSunday:values.isSunday,
      out_Time:values.out_Time
    };
    try {
      const response = await AddOrUpdateVisitorWithoutLogin(Data);
      if (response?.status === 200) {
        // navigate(routes?.allvisitorlist.match); // Navigate to the visitor list
        if(id) {
          toast.success("Visitor Updated Successfully")
        } else {
          toast.success("Visitor Added Successfully")
        }
         resetForm({
        values: {
          ...formik.initialValues,
          visitingDate: null,
          validUpto: null,
        }
      });
      }
    } catch (e) {
      console.log(e, "error");
    }
  };
  const [visibleSunday,setVisibleSunday]=useState(false)
  const [checkSunday,setCheckSunday]=useState(true)
  const handleSunday = () => {
  const date = new Date(values.visitingDate);
  if (date.getDay() === 0) {
    setVisibleSunday(true);
    // Don't toggle here, just set as needed
    setCheckSunday(values.isSunday === true);
  } else {
    setVisibleSunday(false);
    setCheckSunday(false);
    setFieldValue("isSunday", false); // Clear the value when not Sunday
  }
};

  const { handleChange, setFieldValue, values } = formik;
useEffect(() => {
  handleSunday();
  setCheckSunday(false);
}, [values.visitingDate]);
return (
    <>
     <PageContainer
          title="Visitor Pass SSWhite Technology"
          description="Add visitor gate pass without login"
        >
      <Breadcrumbs
        title={`${visitorid ? (view ? "View" : "Edit") : "Add"} Visitor`}
        items={BCrumb}
      />
      <Card
        sx={{
          p: 0,
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          p={2}
          sx={{
            backgroundColor: "primary.light",
            color: "primary.main",
          }}
        >
          <FeatherIcon icon="alert-circle" width="18" />
          <Box sx={{ ml: 1 }}>{`${visitorid ? (view ? "View" : "Edit") : "Add"
            } Visitor`}</Box>
        </Box>

        <Box style={{ padding: "10px" }}>
          <Stack spacing={1}>
            {formik.touched.initiatorName &&
              formik.errors.initiatorName && (
                <Alert variant="filled" severity="error">
                  {formik.touched.initiatorName &&
                    formik.errors.initiatorName}
                </Alert>
              )}
            {formik.touched.department && formik.errors.department && (
              <Alert variant="filled" severity="error">
                {formik.touched.department && formik.errors.department}
              </Alert>
            )}

            {formik.touched.representing && formik.errors.representing && (
              <Alert variant="filled" severity="error">
                {formik.touched.representing && formik.errors.representing}
              </Alert>
            )}
            {formik.touched.contactNO && formik.errors.contactNO && (
              <Alert variant="filled" severity="error">
                {formik.touched.contactNO && formik.errors.contactNO}
              </Alert>
            )}
            {formik.touched.visitingPersonname && formik.errors.visitingPersonname && (
              <Alert variant="filled" severity="error">
                {formik.touched.visitingPersonname && formik.errors.visitingPersonname}
              </Alert>
            )}
            {formik.touched.validUpto && formik.errors.validUpto && (
              <Alert variant="filled" severity="error">
                {formik.touched.validUpto && formik.errors.validUpto}
              </Alert>
            )}
            {formik.touched.VisitingTime && formik.errors.VisitingTime && (
              <Alert variant="filled" severity="error">
                {formik.touched.VisitingTime && formik.errors.VisitingTime}
              </Alert>
            )}
            {formik.touched.noofPerson && formik.errors.noofPerson && (
              <Alert variant="filled" severity="error">
                {formik.touched.noofPerson && formik.errors.noofPerson}
              </Alert>
            )}
            {formik.touched.purpose && formik.errors.purpose && (
              <Alert variant="filled" severity="error">
                {formik.touched.purpose && formik.errors.purpose}
              </Alert>
            )}
            {formik.touched.visitingType && formik.errors.visitingType && (
              <Alert variant="filled" severity="error">
                {formik.touched.visitingType && formik.errors.visitingType}
              </Alert>
            )}
             {formik.touched.isSunday && formik.errors.isSunday && (
              <Alert variant="filled" severity="error">
                {formik.touched.isSunday && formik.errors.isSunday}
              </Alert>
            )}
          </Stack>
        </Box>
        
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Box sx={{ width: "100%", typography: "body1" }}>
              <Card>
                <CreateVisitorWLogin
                  values={values}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  employeeData={employeeData}
                  departments={departments}
                  view={view}
                  visibleSunday={visibleSunday}
                  handleSunday={handleSunday}
                  checkSunday={checkSunday}
                  setCheckSunday={setCheckSunday}
                />
              </Card>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
              {!view &&
                (<Button variant="contained" color="primary" type="submit" sx={{ mr: 2 }}>
                  {id ? "Edit Visitor" : "Add Visitor"}
                </Button>)
              }
            </Box>

          </Form>
        </FormikProvider>
      </Card>
    </PageContainer>
    </>
  );
};

export default CreateVisitorW;
